import styled from 'styled-components';

export const Hr = styled.div`
  width: 100%;
  clear: both;
  height: 1px;
  display: block;
  margin: 0;
  background: rgba(116, 116, 116, 0.15);
`;
